import { fetchExactagCustomerData } from "./api"
import * as exactag from "@otto-ec/online-marketing/exactag"
import { toggle } from "@otto-ec/global-resources/toggle"
import { onCustomerSessionRefresh } from "@otto-ec/fti-customer-session-frontend"


export function trackCustomerData() {
    exactag.registerVerticalDataCallback("customerData", async () => {
        if (toggle.get("fti_enable_exactag_by_ost")) {
            return new Promise<any>((resolve) => {
                onCustomerSessionRefresh.subscribe(async () => {
                    try {
                        const data = await fetchExactagCustomerData()
                        resolve(data)
                    } catch (error) {
                        console.error("Failed to fetch customer's exactag data:", error)
                        resolve(null)
                    }
                }, { once: true })
            })
        } else {
            try {
                return await fetchExactagCustomerData()
            } catch (error) {
                console.error("Failed to fetch customer's exactag data:", error)
                return null
            }
        }
    })
}

trackCustomerData()
